import { Select } from '@mui/material';

import { GDMSelectComponent } from './GDMSelect.type';

/* TODO: Implement component using GDM default design */
const GDMSelect: GDMSelectComponent = props => <Select {...props} />;

export default GDMSelect;
